import React from 'react'
import { Lazyload, Button } from '~/components'
import * as st from '~/assets/styl/Welcome.module.styl'
import img1 from '~/assets/img/lounge-area-comum.webp'
import img2 from '~/assets/img/piscina-espreguicadeiras.webp'
import { useLanguage } from '~/hooks'

export default function Welcome() {
  const { t } = useLanguage()
  return (
    <section className={st.core}>
      <Lazyload src={img1} className={st.img} />
      <div className={st.paragraph}>
        <p>{t('Welcome.paragraph')}</p>
      </div>
      <div className={st.cta}>
        <h3>{t('Welcome.title')}</h3>
        <Button href="/#Rodape">{t('Welcome.button')}</Button>
      </div>
      <Lazyload src={img2} className={st.img} />
    </section>
  )
}
